import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
export var AccurityDnDProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(DndProvider, { backend: HTML5Backend }, children));
};
export default AccurityDnDProvider;
//# sourceMappingURL=AccurityDnDProvider.js.map